import { fetcher } from "helpers/fetcher";

import { TPublishJobReq, TPublishJobRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const publishJob = async (payload?: TPublishJobReq) => {
  return await fetcher<TPublishJobRes, TPublishJobReq["data"]>(
    ENDPOINT.BU.PUBLISH_JOB,
    {
      data: payload?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.PUBLISH_JOB.version,
        [API_HEADER.BU_ID]: payload?.idBu,
      },
    }
  );
};

export const mutationPublishJob = async (payload?: TPublishJobReq) => {
  return (await publishJob(payload)).data;
};

mutationPublishJob._key = (payload?: TPublishJobReq) => [
  ENDPOINT.BU.PUBLISH_JOB.url,
  payload,
];
